// Apresentação apenas: o erro original deve continuar disponível para diagnóstico.
const TECHNICAL_TEXT = /firebase(?:error)?|permission[-_ ]denied|missing or insufficient permissions|unauthenticated|auth\/|functions\/|storage\/|firestore|webchannel|indexeddb|chunkloaderror|loading chunk|dynamically imported module|unexpected token|failed to (?:fetch|load)|network(?:error|requestfailed|-request-failed)|deadline[-_ ]exceeded|resource[-_ ]exhausted|\b(?:internal|unavailable|timeout|rejected|undefined|NaN|ECONN\w*|ETIMEDOUT)\b|(?:type|reference|syntax|range)error|cannot (?:read|access)|request failed|something went wrong|invalid[-_ ](?:argument|credential)|failed[-_ ]precondition|data[-_ ]loss|client is offline|^\s*offline\s*$|not[- ]found|not allowed|\bHTTP\s*\d{3}\b|\[object Object\]|\b(?:payload|endpoint|callable|stack trace)\b|(?:webpack:|\/workspace\/|node_modules\/)|\bat \w+.*:\d+:\d+/i;

const readFeedback = (value) => {
  if (value == null || value === false) return {message: '', code: ''};
  if (typeof value === 'string' || typeof value === 'number') return {message: String(value), code: ''};
  if (typeof value === 'object') {
    const message = value.message || value.error?.message || (typeof value.error === 'string' ? value.error : '');
    return {message: typeof message === 'string' ? message : '', code: String(value.code || value.error?.code || '')};
  }
  return {message: '', code: ''};
};

export const isTechnicalFeedback = (value) => {
  const {message, code} = readFeedback(value);
  return TECHNICAL_TEXT.test(`${code} ${message}`);
};

const translatedMessage = (signature) => {
  if (/too-many-requests|resource[-_ ]exhausted|quota|rate[-_ ]limit|\bHTTP\s*429\b/i.test(signature)) {
    return 'Houve muitas tentativas em pouco tempo. Aguarde alguns minutos e tente novamente.';
  }
  if (/auth\/(?:network-request-failed)|failed to fetch|network(?:error|-request-failed)|webchannel|offline|timeout|deadline[-_ ]exceeded|ECONN|ETIMEDOUT/i.test(signature)) {
    return 'Não foi possível confirmar a resposta do sistema. Confira sua internet e atualize a tela antes de tentar novamente.';
  }
  if (/auth\/(?:invalid-credential|wrong-password|user-not-found|invalid-email)|invalid credential/i.test(signature)) {
    return 'Confira os dados de acesso que você informou e tente novamente.';
  }
  if (/auth\/email-already-in-use/i.test(signature)) {
    return 'Este e-mail já está cadastrado. Use outro e-mail ou recupere seu acesso.';
  }
  if (/auth\/weak-password/i.test(signature)) {
    return 'Escolha uma senha mais forte e confira as orientações do campo de senha.';
  }
  if (/auth\/user-disabled/i.test(signature)) {
    return 'Seu acesso está desativado. Fale com o responsável pelo sistema.';
  }
  if (/unauthenticated|auth\/(?:user-token-expired|invalid-user-token)|sess[aã]o (?:firebase )?(?:n[aã]o autenticada|indispon[ií]vel|alterada)|sess[aã]o.*expir/i.test(signature)) {
    return 'Entre novamente no sistema para continuar.';
  }
  if (/permission[-_ ]denied|missing or insufficient permissions|storage\/unauthorized|\bHTTP\s*403\b/i.test(signature)) {
    return 'Você não tem permissão para fazer isso. Se precisar desse acesso, fale com o responsável pelo sistema.';
  }
  if (/chunkloaderror|loading chunk|dynamically imported module|unexpected token\s*['"]?</i.test(signature)) {
    return 'Não foi possível abrir esta tela. Atualize a página e tente novamente.';
  }
  if (/storage\/(?:object-not-found|bucket-not-found)/i.test(signature)) {
    return 'O arquivo não foi encontrado. Atualize a página e confira se ele ainda está disponível.';
  }
  if (/storage\/canceled|storage\/cancelled/i.test(signature)) {
    return 'O envio do arquivo foi cancelado. Se quiser continuar, selecione o arquivo novamente.';
  }
  if (/storage\//i.test(signature)) {
    return 'Não foi possível acessar o arquivo agora. Tente novamente. Se continuar, fale com o suporte.';
  }
  if (/not[- ]found|\bHTTP\s*404\b/i.test(signature)) {
    return 'A informação não foi encontrada. Atualize a tela e confira o item selecionado.';
  }
  return 'Não foi possível concluir esta ação agora. Atualize a tela e confira o resultado. Se precisar de ajuda, fale com o suporte.';
};

export const getHumanFeedbackMessage = (value, {fallback = ''} = {}) => {
  const {message, code} = readFeedback(value);
  const text = message.trim();
  if (!text && !code) {
    if (value && typeof value === 'object') return translatedMessage('');
    return fallback ? getHumanFeedbackMessage(fallback) : '';
  }
  // Uma validação de negócio já escrita em português mantém a orientação específica,
  // mesmo se o backend anexar um código técnico à exceção.
  if (text && !TECHNICAL_TEXT.test(text)) return text.replace(/^Error:\s*/i, '');
  return translatedMessage(`${code} ${text}`);
};
